export const profile = {
  'profile.theClubUserProfile.title': 'Perfil de Usuario del Club',
  'profile.theClubUserProfile.userStatus': 'Estado del Usuario',
  'profile.theClubUserProfile.username': 'Nombre de Usuario',
  'profile.theClubUserProfile.memberSince': 'Miembro Desde',
  'profile.theClubUserProfile.sponsor': 'Patrocinador',
  'profile.theClubUserProfile.referralLink': 'Enlace de Referido',
  'profile.theClubUserProfile.commissionModel': 'Modelo de Comisión',
  'profile.theClubUserProfile.commissionLevels': 'Niveles de Comisión',
  'profile.theClubUserProfile.commissionlevel': 'Nivel',
  'profile.theClubUserProfile.rank': 'Rango',
  'profile.theClubUserProfile.copyTooltip': '¡Copiado al portapapeles!',
  'profile.theClubUserProfile.copyReferralLink': 'Copiar enlace de referido',
  'profile.theClubUserProfile.userInformation': 'Información del Usuario',
  'profile.personalInformation.title': 'Mi Información Personal',
  'profile.personalInformation.firstName': 'Nombre',
  'profile.personalInformation.lastName': 'Apellido',
  'profile.personalInformation.email': 'Correo Electrónico',
  'profile.personalInformation.phone': 'Teléfono',
  'profile.personalInformation.dateOfBirth': 'Fecha de Nacimiento',
  'profile.personalInformation.gender': 'Género',
  'profile.personalInformation.country': 'País',
  'profile.personalInformation.address': 'Dirección',
  'profile.personalInformation.city': 'Ciudad',
  'profile.personalInformation.postalCode': 'Código Postal',
  'profile.personalInformation.edit': 'Editar',
  'profile.personalInformation.save': 'Guardar',
  'profile.personalInformation.cancel': 'Cancelar',
  'profile.personalInformation.male': 'Masculino',
  'profile.personalInformation.female': 'Femenino',
  'profile.personalInformation.other': 'Otro',
  'profile.personalInformation.saving': 'Guardando...',
  'profile.personalInformation.selectGender': 'Seleccionar género',
  'profile.personalInformation.saveChanges': 'Guardar cambios',
  'profile.paymentMethods.title': 'Mis Métodos de Pago',
  'profile.paymentMethods.cryptoWallet': 'Billetera Cripto',
  'profile.paymentMethods.bankAccount': 'Cuenta Bancaria',
  'profile.paymentMethods.network': 'Red',
  'profile.paymentMethods.currency': 'Moneda',
  'profile.paymentMethods.address': 'Dirección',
  'profile.paymentMethods.accountNumber': 'Número de Cuenta',
  'profile.paymentMethods.routingNumber': 'Número de Ruta',
  'profile.paymentMethods.bankName': 'Nombre del Banco',
  'profile.paymentMethods.accountHolderName': 'Nombre del Titular',
  'profile.paymentMethods.swiftCode': 'Código SWIFT',
  'profile.paymentMethods.edit': 'Editar',
  'profile.paymentMethods.save': 'Guardar',
  'profile.paymentMethods.cancel': 'Cancelar',
  'profile.paymentMethods.cryptoWalletHeader': 'Billetera de Criptomonedas',
  'profile.paymentMethods.bankAccountHeader': 'Detalles de Cuenta Bancaria',
  'profile.paymentMethods.selectNetwork': 'Seleccionar red',
  'profile.paymentMethods.selectCurrency': 'Seleccionar moneda',
  'profile.paymentMethods.walletAddressPlaceholder': 'Dirección de billetera',
  'profile.paymentMethods.accountNumberPlaceholder': 'Número de cuenta',
  'profile.paymentMethods.bankNamePlaceholder': 'Nombre del banco',
  'profile.paymentMethods.accountHolderPlaceholder': 'Nombre del titular',
  'profile.paymentMethods.routingNumberPlaceholder': 'Número de ruta',
  'profile.paymentMethods.swiftCodePlaceholder': 'Código SWIFT/BIC',
  'profile.referralLink.title': 'Mi Enlace de Referido',
  'profile.referralLink.description': 'Usa tu enlace de referido para invitar a familiares, amigos y colegas a unirse a The Club. Cuando se registren usando tu enlace, ganarás comisiones de sus ganancias según tu modelo de comisiones.',
  'profile.referralLink.howToUse': 'Cómo usar tu enlace de referido:',
  'profile.referralLink.step1': 'Copia tu enlace único de referido a continuación',
  'profile.referralLink.step2': 'Compártelo con personas que conozcas y que estén interesadas en inversiones y en trading',
  'profile.referralLink.step3': 'Cuando se registran usando tu enlace, se convierten en parte de tu comunidad',
  'profile.referralLink.step4': 'Gana comisiones de sus ganancias según tu estructura de comisiones',
  'profile.referralLink.yourLink': 'Tu Enlace de Referido',
  'profile.referralLink.partnerLink': 'Enlace de Referido Partner',
  'profile.referralLink.partnerDescription': 'Comparte este enlace con personas que quieran construir su propia red de referidos. Heredarán tu plan de comisiones.',
  'profile.referralLink.clientLink': 'Enlace de Referido Cliente',
  'profile.referralLink.clientDescription': 'Comparte este enlace con personas que solo quieran invertir. No tendrán una red de referidos.',
  'profile.referralLink.notAvailable': 'Los enlaces de referido no están disponibles para tu tipo de cuenta.',
  'profile.referralLink.copyTooltip': '¡Copiado al portapapeles!',
  'profile.referralLink.copyReferralLink': 'Copiar enlace de referido',
  'profile.referralLink.tipsForSuccessTitle': 'Consejos para el Éxito:',
  'profile.referralLink.tipsForSuccessTip1': 'Comparte tu enlace con personas que realmente estén interesadas en inversiones y en trading',
  'profile.referralLink.tipsForSuccessTip2': 'Explica los beneficios de unirse a The Club y cómo funcionan nuestros programas de inversión',
  'profile.referralLink.tipsForSuccessTip3': 'Mantente disponible para responder preguntas y brindar apoyo a tus referidos',
  'profile.referralLink.tipsForSuccessTip4': 'Monitorea tus ganancias por comisiones en la sección "Mis Ganancias"',
  'profile.common.loading': 'Cargando...',
  'profile.common.error': 'Error al cargar datos',
  'profile.common.noData': 'No hay datos disponibles',
  'profile.common.updateSuccess': 'Información actualizada exitosamente',
  'profile.common.updateError': 'Error al actualizar información',
  'profile.common.defaultUser': 'Usuario',
  'profile.common.defaultUsername': 'usuario',
  'profile.common.userMustBeActive': 'El usuario debe estar activo',
  'profile.errorHandling.fillRequiredFields': 'Por favor complete todos los campos requeridos correctamente',
  'profile.validation.firstName': 'Nombre',
  'profile.validation.lastName': 'Apellido',
  'profile.validation.country': 'País',
  'profile.validation.address': 'Dirección',
  'profile.validation.city': 'Ciudad',
  'profile.validation.accountNumber': 'Número de cuenta',
  'profile.validation.bankName': 'Nombre del banco',
  'profile.validation.accountHolderName': 'Nombre del titular',
  'profile.validation.routingNumber': 'Número de ruta',
  'profile.validation.swiftCode': 'Código SWIFT',
  'profile.validation.required': 'es requerido',
  'profile.validation.minLength': 'debe tener al menos {count} caracteres',
  'profile.validation.maxLength': 'no debe tener más de {count} caracteres',
  'profile.validation.nameFormat': 'solo puede contener letras, espacios, guiones y apostrofes',
  'profile.validation.phoneFormat': 'Por favor ingrese un número de teléfono válido',
  'profile.validation.dateOfBirth': 'Debe ser una fecha válida y edad entre 18-100 años',
  'profile.validation.postalCode': 'Por favor ingrese un código postal válido',
  'profile.validation.minLengthAfterSanitization': 'debe tener al menos {count} caracteres después de la sanitización',
  'profile.validation.selectNetwork': 'Por favor seleccione una red',
  'profile.validation.selectCurrency': 'Por favor seleccione una moneda',
  'profile.validation.walletAddressFormat': 'La dirección de billetera solo puede contener letras y números',
  'profile.validation.accountNumberFormat': 'El número de cuenta debe contener solo dígitos',
  'profile.validation.bankNameFormat': 'El nombre del banco contiene caracteres inválidos',
  'profile.validation.accountHolderFormat': 'El nombre del titular solo puede contener letras, espacios, guiones, apostrofes y puntos',
  'profile.validation.routingNumberFormat': 'El número de ruta debe tener exactamente 9 dígitos',
  'profile.validation.swiftCodeFormat': 'Por favor ingrese un código SWIFT/BIC válido',
  'profile.toast.error': 'Error',
  'profile.toast.success': 'Éxito',
  'profile.toast.validationError': 'Error de Validación',
};
